
import { post, get } from '@/utils/request';

// @aigc:start 2024/03/12-16:29
// 获取会员卡详情
export const getVipCardDetail = (params) => get('member/card/desc/v1', params);

// @aigc:end 2024/03/12-16:29


// @aigc:start 2024/04/03-14:53
// 会员卡成功页数据
export const getVipCardInfo = (params) => get('member/card/user/info', params);
// @aigc:end 2024/04/03-14:53

// 兑换页面的 兑换弹框接口
export const getExchangePool = (params, config) => get('member/card/user/exchange/pool/get', params, config);

// 兑换的提交
export const postExchangePoolSub = (data) => post('member/card/user/exchange/pool/submit', data);

// 获取会员卡推荐购买金额
export const getMemberSkip = (params) => get('member/card/skip/goods', params);

// 获取购买成功跳转地址
export const getCircleLink = (params) => get('member/card/circle/linkUrl', params);